const validate = values => {
    const errors = {modelo: ''};

    if (!values.modelo) {
        errors.modelo = 'Escoja un modelo';
    }
    return errors;
};

export default validate;


// WEBPACK FOOTER //
// ./src/components/pages/visicooler/nuevo/validate.ts